import React from 'react'
import Images from '../../Assets/images/Images'
import { social } from '../../Constants/constant'
import Icons from '../../Assets/icons/Icons'
import style from './Footer.module.css'

function Footer() {
  return (
    <footer className={style.footer}>
      <section className={style.top_footer}>
        <div className={style.logos}>
          <div className={style.logo}>
            <img src={Images.logo}  alt='lexrae support' />
          </div>
          <p>
          Empowering lives through compassionate, person-centred care with dignity and
          respect.
          </p> 
          <ul className={style.socials}>
            {social.map((e)=>(
              <li key={e.name}>
                <a
                  href={e.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={e.name}  
                >
                  {e.icon}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className={style.info}>
          <div className={style.address}>
            <h4>Office Address</h4>
            <p>Lexrae Support Ltd, Edward James House, Hadley, Telford, TF1 6QJ</p>
          </div>
          
          <div className={style.contact}>
            <h4>Contact us</h4>
            <div className={style.mail}>
              {Icons.mail}
              <p>admin@lexraesupport.co.uk</p>
            </div>
          </div>

          <div className={style.time}>
            <h4>Visitation Hours</h4>
            <p>Mon-Fri: 8:00am - 5:00pm </p>
          </div>
          
        </div>
      </section>
      <section className={style.down_footer}>
        <p>© 2025 Lexrae support - All rights reserved</p>
        <a
          href="https://drive.google.com/file/d/10yMYZLioeiqf5wy9IJmQm5h_QziCyisY/view?usp=drive_link" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Terms & Conditions
        </a>
      </section>
    </footer>
  )
}

export default Footer